module.exports = __webpack_public_path__ + "images/emoji/customs.e13bbff3b0d4567fb634.png";